import React, { useCallback } from 'react';
import { Tappable } from '@vectord/components';

import { setAcademyProjectDetailsModalState } from 'features/classCreation';
import useAppDispatch from 'hooks/useAppDispatch';

function AcademyProjectDetailsButton({
  isAcademyProjectPresent,
}: IAcademyProjectDetailsButton) {
  const dispatch = useAppDispatch();
  const handleOnClick = useCallback(() => {
    dispatch(setAcademyProjectDetailsModalState(true));
  }, [dispatch]);

  if (isAcademyProjectPresent) {
    return (
      <Tappable
        className="primary h5 m-l-m"
        noHighlight
        onClick={handleOnClick}
      >
        Details
      </Tappable>
    );
  }
  return null;
}

export default AcademyProjectDetailsButton;
